import { render } from "./FacetItemText.vue?vue&type=template&id=0e42914a"
import script from "./FacetItemText.vue?vue&type=script&lang=js"
export * from "./FacetItemText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__